/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Prompt1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Prompt from 'DesignSystem/Questions/Prompt/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Prompt1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Prompt"
  
}) {
let questionPromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'prompt',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.populateTemplate(questionPromptValueData, selectedAnswersValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let questionSubPromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'subPrompt',
})
  return (<React.Fragment
>
<div
  data-testid="Prompt.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Prompt
  viewPath={`${viewPath}/Prompt`}
 marginTop={dtSpaceXxs}
 marginBottom={0}
 data="question.prompt"
 data="selected.answers"
 aggregate="./helpers.js populateTemplate"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 marginTop={dtSpaceXxs}
 data="question.subPrompt"
 text={questionSubPromptValueData}
/>
</div>
{children}
</React.Fragment>)
}